import { Column, CreateDateColumn, Entity, OneToMany, PrimaryGeneratedColumn, Unique, UpdateDateColumn, VersionColumn } from "typeorm";
import { FarmTypesEnum, HarvestTypes, Indentstatusenum, PlantsEnum, RMInwardTypeEnum, SupplierTypeEnum, VehicleTypeEnum } from '@gtpl/shared-models/common-models';
import { CommissionType, HarvestingTime } from '@gtpl/shared-models/raw-material-procurement';
import { IndentItems } from "./indent-items.entity";
import { FarmTypeEnum } from "@gtpl/shared-models/masters";
@Entity("indent")
export class Indent {
    @PrimaryGeneratedColumn("increment", { name: 'indent_id' })
    indentId: number;

    @Column("varchar", {
        nullable: false,
        length: 30,
        name: "indent_code"
    })
    indentCode: string;

    @Column({
        nullable: false,
        name: "indent_date"
    })
    indentDate: Date;

    @Column({
        type: 'enum',
        enum: SupplierTypeEnum,
        nullable: false,
        default: SupplierTypeEnum.FARMER,
        name: 'supplier_type'
    })
    supplierType: SupplierTypeEnum;

    

    @Column({
        type: 'enum',
        enum: CommissionType,
        nullable: true,
        default: CommissionType.PERCENTAGE,
        name: 'commission_type'
    })
    commissionType: CommissionType;  

    @Column("decimal", {
        nullable: true,
        precision:10,scale:2,
        name: "commission"
    })
    commission: number;

    @Column({
        nullable: true,
        name: "harvesting_date"
    })
    harvestingDate: Date;

    @Column({
        type: 'enum',
        enum: HarvestingTime,
        nullable: true,
        default: HarvestingTime.MORNING,
        name: 'harvesting_time'
    })
    harvestingTime: HarvestingTime;    
    @Column("int", {
        nullable: true,
        name: "indent_by"
    })
    indentBy: number;  

    @Column("int", {
        nullable: true,
        name: "assign_lead_1"
    })
    assignLead1: number;

    @Column("int", {
        nullable: true,
        name: "assign_lead_2"
    })
    assignLead2: number;

    @Column("boolean", {
        nullable:true,
        default:false,
        name: "vehicle_assigned"
      })
    vehicleAssigned: boolean;

    @Column("boolean", {
        nullable:false,
        default:false,
        name: "grn_completed"
      })
    grnCompleted: boolean;

    @Column({
        type: 'int',
        nullable: true,
        default: 0,
        name: 'plant_id'
    })
    plantId: number;

    @Column("boolean", {
        nullable:true,
        // default:false,
        name: "is_vehicle_required"
      })
      isVehicleRequired: boolean;

    @Column({
    type: 'enum',
    nullable: false,
    enum: HarvestTypes,
    name: "harvest_type"
    })
    harvestType: HarvestTypes;


    @Column("boolean",{
        nullable:false,
        default:true,
        name:"is_active"
    })
    isActive:boolean;

    @CreateDateColumn({ name: "created_at" })
    createdAt: Date;

    @Column("varchar", {
        nullable: false,
        length: 40,
        default: 'Admin',
        name: "created_user"
    })
    createdUser: string | null;

    @UpdateDateColumn({ name: "updated_at" })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        length: 40,
        name: "updated_user"
    })
    updatedUser: string | null;


    @Column({
        type: 'enum',
        enum: Indentstatusenum,
        name: 'indent_status',
        default: Indentstatusenum.OPEN,
        nullable: false,

    })
    indentStatus: Indentstatusenum;  

        @Column({
            type: 'enum',
            enum: FarmTypesEnum,
            name: 'farm_type',
        nullable: true,
        })
        farmType: FarmTypesEnum;  

        @Column({
            type: 'int',
            name: 'cance_reason',
        nullable: true,
        })
        cancelReason: number; 

    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;

    @Column({
  type: 'enum',
  enum: RMInwardTypeEnum,
  nullable: true,
  name: 'rm_inward_type'
})
rmInwardType: RMInwardTypeEnum;
@Column("varchar", {
  nullable: true,
  length: 50,
  name: "boe_num"
})
boeNum: string;

@Column("timestamp", {
  nullable: true,
  name: "boe_date"
})
boeDate: Date;
    @OneToMany(type => IndentItems, indentItems => indentItems.indentInfo, { cascade: true })
    indentItemsInfo: IndentItems[];
}

